import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class NumberFormatService {
  toFixed = (value: string | number | undefined | null, decimals: number = 2): string => {
    if (!value)
      return "";

    let formattedValue = String(value).split(" ").join("");

    formattedValue = formattedValue.replace(",", ".");

    if (formattedValue.includes(".") && formattedValue.split(".").length === decimals) {
      const decimalLength = formattedValue.split(".")[1]?.length;
      if (decimalLength && decimalLength > decimals) {
        return Number.parseFloat(formattedValue).toFixed(decimals);
      }
    }

    return formattedValue;
  };
}
